import { Layer } from "@/types";

export const parseMetaData = (layers: Layer[]) => {
  return layers.map((layer) => {
    return { ...layer, metadata: JSON.parse(layer.metadata) };
  });
};
